module.exports = [{"key":"5","text":"Ikke tilknyttet program"},{"key":"4","text":"Digitalisering"},{"key":"3","text":"IT i forskningen"},{"key":"2","text":"IT i utdanningen"},{"key":"1","text":"IT i virksomheten"},{"key":"0","text":"Basis IT"}]


//////////////////
// WEBPACK FOOTER
// ./src/constants/program.json
// module id = 702
// module chunks = 0